var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-menu-icon",class:[_vm.iconActive ? 'active' : ''],on:{"click":_vm.setIconActive}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }